var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", [
        _vm._v("\n\t\tAufgrund der letzten Schritte mit "),
        _c("b", [_vm._v(_vm._s(_vm.applicantName))]),
        _vm._v(", besteht seitens "),
        _c("b", [_vm._v(_vm._s(_vm.companyName))]),
        _vm._v("\n\t\tInteresse an einer Zusammenarbeit.\n\t")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n\t\tEs folgen nun - soweit "),
        _c("b", [_vm._v(_vm._s(_vm.applicantName))]),
        _vm._v(
          " auch interessiert ist - die Verhandlungen über\n\t\tdie näheren Details, wie Gehalt, Beginn der Tätigkeit und andere Fragen.\n\t"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _c("b", [
          _vm._v(
            _vm._s(_vm.applicantName) + ", erhält folgende Nachricht von dir:"
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "InfoBox",
        {
          staticClass: "my-3",
          attrs: { "with-icon": false, type: "purple-lightest" }
        },
        [_c("nl2br", { attrs: { tag: "div", text: _vm.text } })],
        1
      ),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n\t\tSobald "),
        _c("b", [_vm._v(_vm._s(_vm.applicantName))]),
        _vm._v(
          " sein Interesse mitteilt, erhältst du für die nächsten Schritte die\n\t\tKontaktdaten von "
        ),
        _c("b", [_vm._v(_vm._s(_vm.applicantName))]),
        _vm._v(", wie E-Mail Adresse und Mobilnummer.\n\t")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }